<div class="roles-container mat-elevation-z2">
    <div class="table-header">
      <h2>Roles Management</h2>
  
      <div class="actions">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search roles</mat-label>
          <input
            matInput
            (keyup)="applyFilter($event)"
            placeholder="Search by role name"
          />
        </mat-form-field>
      
        <div class="button-group">
          <button mat-raised-button color="accent" (click)="openPermissionDialog()">
            Add Permission
          </button>
          <button mat-raised-button color="primary" (click)="openRoleDialog()">
            Add Role
          </button>
        </div>
      </div>
      
    </div>
  
    <div class="mat-elevation-z8">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="mat-elevation-z1 full-width-table"
      >
        <!-- Role Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Role Name</th>
          <td mat-cell *matCellDef="let role">{{ role.name }}</td>
        </ng-container>
  
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let role">
            <button mat-icon-button [matMenuTriggerFor]="roleActionsMenu" matTooltip="Role Actions">
              <mat-icon>menu</mat-icon>
            </button>
            <mat-menu #roleActionsMenu="matMenu">
              <button mat-menu-item (click)="openRoleDialog(role)">
                <mat-icon>edit</mat-icon>
                <span>Edit Role</span>
              </button>
              <button mat-menu-item (click)="deleteRole(role.id)">
                <mat-icon>delete</mat-icon>
                <span>Delete Role</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
  
      <mat-paginator
        [pageSizeOptions]="[5, 10, 25]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
  
